import styled from 'styled-components'

const DashboardHeaderBackground = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  // same color and height as in the DashboardColumn header
  height: 145px;
  background-color: #1f4565;
`

export default DashboardHeaderBackground
